import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { DialogCommerceComponent } from './dialog-commerce.component';

@NgModule({
  declarations: [DialogCommerceComponent],
  exports: [DialogCommerceComponent],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    TranslateModule.forChild({
      isolate: false
    })
  ]
})
export class DialogCommerceModule {}
